/**
 * HeroSection Component
 * Landing page hero with animated background
 */

import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Zap, Shield, TrendingUp } from "lucide-react";

export const HeroSection = () => {
  return (
    <section className="relative pt-32 pb-20 px-6 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 gradient-animate opacity-50"></div>
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl animate-pulse float"></div>
        <div
          className="absolute bottom-20 right-10 w-96 h-96 bg-secondary/10 rounded-full blur-3xl animate-pulse float"
          style={{ animationDelay: "2s" }}
        ></div>
      </div>

      <div className="container mx-auto max-w-4xl text-center relative z-10">
        <h1 className="text-6xl md:text-7xl font-bold text-primary mb-6 leading-tight">
          The Golden Touch for <br />
          E-commerce.
        </h1>
        <p className="text-xl text-foreground/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          Your all-in-one AI studio for virtual try-ons, product staging, ad
          generation, and more. Stop guessing, start visualizing.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Button variant="hero" size="lg" asChild className="glow-hover">
            <Link to="/app">
              Start Your Free Trial
              <ArrowRight className="ml-2" size={20} />
            </Link>
          </Button>
          <Button
            variant="outline"
            size="lg"
            asChild
            className="glass glass-hover"
          >
            <a href="#features">Explore Features</a>
          </Button>
        </div>

        {/* Trust Badges */}
        <div className="flex items-center justify-center gap-8 mt-12 text-muted-foreground">
          <div className="flex items-center gap-2">
            <Zap className="text-primary" size={20} />
            <span className="text-sm">Lightning Fast</span>
          </div>
          <div className="flex items-center gap-2">
            <Shield className="text-primary" size={20} />
            <span className="text-sm">Enterprise Grade</span>
          </div>
          <div className="flex items-center gap-2">
            <TrendingUp className="text-primary" size={20} />
            <span className="text-sm">Proven Results</span>
          </div>
        </div>
      </div>
    </section>
  );
};
